import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "../../assets/css/mon-css.css";
import { listLeftDatas } from "./list-left";

export default function ListLeftResponsive({
  display,
  setDisplay,
  nombreDeSms,
  nombreDeSmsGroupe,
}) {
  const boxRefDropdownMenuResponsive = useRef();

  // Fermer si clic à l'extérieur
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        boxRefDropdownMenuResponsive.current &&
        !boxRefDropdownMenuResponsive.current.contains(event.target) &&
        !event.target.closest(".dropdown-menu-responsive-toggle-button")
      ) {
        setDisplay(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <>
      <div
        ref={boxRefDropdownMenuResponsive}
        className={`dropdown-menu dropdown-menu-auto dropdown-menu-end ${
          display
            ? "show affiche-la-liste-responsive animate__animated animate__backInLeft animate__repeat-1"
            : ""
        }`}
      >
        <ul className="tyn-list-links">
          <li>
            <h3 className="tyn-list-links-heading">Menu</h3>
          </li>
          {listLeftDatas.map((element, index) => (
            <li key={index}>
              {index === 0 ? (
                <>
                  <Link to={element.linkTo}>
                    {element.icon}
                    <span>{element.span}</span>
                    {nombreDeSms > 0 && (
                      <div
                        className="badge bg-primary position-absolute rounded-pill"
                        style={{ top: "51px", left: "120px" }}
                      >
                        {nombreDeSms}
                      </div>
                    )}
                  </Link>
                </>
              ) : // : index === listLeftDatas.length - 1 ||
              //   index === listLeftDatas.length - 3 ? (
              //   user.rang < 4 ? (
              //     <>
              //       <Link to={element.linkTo}>{element.icon}</Link>
              //     </>
              //   ) : (
              //     <></>
              //   )
              // ) : index === listLeftDatas.length - 2 ? (
              //   <>
              //     <Link to={element.linkTo} rel="noopener noreferrer">
              //       {element.icon}
              //       <span>{element.span}</span>
              //     </Link>
              //   </>
              // )
              index === 2 ? (
                <>
                  <Link to={element.linkTo} style={{ position: "relative" }}>
                    {element.icon}
                    <span>{element.span}</span>{" "}
                    {nombreDeSmsGroupe > 0 && (
                      <div
                        className="badge bg-primary position-absolute rounded-pill"
                        style={{ top: "10px", left: "120px" }}
                      >
                        {nombreDeSmsGroupe + 3}
                      </div>
                    )}
                  </Link>
                </>
              ) : (
                <>
                  <Link to={element.linkTo}>
                    {element.icon}
                    <span>{element.span}</span>
                  </Link>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
